import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Specific component for approval signature with sso
 */
@Component({
    selector: 'core-layout-modal-signature',
    templateUrl: './modal-signature.component.html',
    styleUrls: ['./modal-signature.component.scss']
})
export class LayoutModalSignatureComponent {
    @Input() title: string;
    @Input() placeholder: string; 
    @Input() type: string; // not used: just in case of more icons in the future (error,done,warning)
    @Input() text: string;
    @Input() label: string = '';
    @Input() required: boolean = true;
    @Input() buttonText: string;
    @Input() secondButtonText: string = ""; //LEFT GREY BUTTON
    @Input() disabled: boolean = false; // white button

    @Output() mainAction = new EventEmitter<string>();
    @Output() secondAction = new EventEmitter<boolean>(); //LEFT GREY BUTTON
    @Output() ssoAction = new EventEmitter<string>(); // SSO 


    public input: string = ''; // input value

    onAction() {
        if (this.isInputReady())
            this.mainAction.emit(this.input);
    }

    onSecondAction() {
        this.secondAction.emit(true);
    }

    onSso(provider:string) {
        this.ssoAction.emit(provider);
    }

    isInputReady() : boolean {
        if(this.required)
            return this.input != '';
        return true;  
    }

}
